import * as React from 'react';
import { GridToolbar, GridToolbarContainer } from '@mui/x-data-grid-pro';
import type { GridToolbarExport } from '@mui/x-data-grid-pro';

import CustomExport from './CustomExport';

type GridToolbarProps = React.ComponentProps<typeof GridToolbar>;
type ExportProps = React.ComponentProps<typeof GridToolbarExport>;

type Props = GridToolbarProps & {
  children?: React.ReactNode;
  exportExtraItems?: React.ReactNode;
  csvOptions?: ExportProps['csvOptions'];
  printOptions?: ExportProps['printOptions'];
};

export default function BaseToolbar({
  children,
  exportExtraItems,
  csvOptions,
  printOptions,
  ...toolbarProps
}: Props) {
  return (
    <div className="tpn-grid-toolbar-scope">
      {exportExtraItems ? (
        <style>
          {`
            .tpn-grid-toolbar-scope .MuiDataGrid-toolbarContainer > .MuiButtonBase-root[aria-label="Export"] {
              display: none !important;
            }
          `}
        </style>
      ) : null}

      <GridToolbarContainer>
        <GridToolbar {...toolbarProps} />

        {exportExtraItems ? (
          <CustomExport
            csvOptions={csvOptions}
            printOptions={printOptions}
            exportExtraItems={exportExtraItems}
          />
        ) : null}
        {children}
      </GridToolbarContainer>
    </div>
  );
}
